import { RootState } from "../../typescript/redux";

export const getState = (state: RootState) => state.timesheetsPage;

export const getTimesheets = (state: RootState) => state.timesheetsPage.list;
